export enum SearchType {
  repairAndMainenance = 'RepairAndMaintenance',
  expense = 'Expense',
  accountsPayable = 'AccountsPayable',
}

export enum NotificationState {
  state = 'None',
  read = 'Read',
  Unread = 'UnRead',
}

export interface SearchRequest {
  ids: string[];
  page: number;
  pageSize: number;
  type?: SearchType;
  /** Revamp list tab key for tab-scoped saved filters (AP / Expense / RM). */
  tab?: string;
  keyword?: string;
  notificationState?: string;
  status?: string[];
}

export interface SearchResponse<T> {
  currentPageIndex: number;
  currentPage: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
  onFirstPage: boolean;
  onLastPage: boolean;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  items: T[];
}

export type Url = 'Notification' | 'vendor' | 'category';
